<template>
  <div class="login-container">
    <div class="left-panel">
      <div class="fontComplet">
        <div class="part1">
          <img src="../assets/logo.png" class="logoCiad" alt="John" />
        </div>
        <div class="part2">
          <div>
            <!-- <span class="firstName">ABIAPHAR </span> -->

            <div class="secondElement">
              <span>
                <span class="thirdElement">ABIAPHAR DISTRIBUTION</span>
                <span class="fourElement">V.1</span></span
              >
            </div>
          </div>
        </div>
        <div class="part3">
          <!-- <img src="../assets/ciad.png" class="logoCiad" alt="John" /> -->
        </div>
      </div>
      <!-- Insérez ici le contenu de la partie gauche de la page, comme le nom du logiciel -->
    </div>
    <div class="right-panel">
      <div class="form">
        <!-- <img src="../assets/logo.png" class="logoCiad" alt="John" /> -->
        <!-- <h4>CONNECTEZ-VOUS À VOTRE COMPTE</h4> -->
        <input
          type="tel"
          v-model="username"
          placeholder="Numéro de téléphone"
        />
        <input type="password" v-model="password" placeholder="Mot de passe" />
        <button @click="submitHandler" type="submit">Se connecter</button>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { login } from "../api/user";
export default {
  name: "loginComponent",
  data: () => ({
    name: "SignIn",
    multiLine: true,
    snackbar: true,
    text: `I'm a multi-line snackbar I'm a multi-line snackbar I'm a multi-line snackbar I'm a multi-line snackbar.`,

    loading: false,
    passwordShow: false,
    username: "",
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    password: "",
    passwordRules: [
      (v) => !!v || "Password is required",
      (v) => (v && v.length >= 6) || "Password must be 6  characters or more!",
    ],
  }),
  methods: {
    async submitHandler() {
      this.loading = true;
      try {
        const response = await login({
          username: this.username,
          password: this.password,
        });
        if (response.success) {
          location.reload();
        } else {
          if (response.message === "This account is not actived") {
            alert("Ce compte n'est pas activé.");
          } else {
            alert("Une erreur s'est produite : " + response.message);
          }
        }
      } catch (error) {
        // alert(error.response.data.error);
        alert("Une erreur s'est produite : " + error.message);
      }
      this.loading = false;
    },
  },
};
</script>
  <style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap");
:root {
  --color-primary: #e9ae53;
  --color-primary-solve: #e9ae5329;
  --color-primary-hard: #916c3a;
  --color-danger: #0482fb;
  --color-success: #71dd37;
  --color-green-white: #e6f9e1;
  --color-blue: #9ae7f8;
  --color-blue-white: #dbf5fb;
  --color-red: #ee3c1f;
  --color-red-white: #fadedc;
  --color-purple: #8c8fff;
  --color-purple-white: #e6e7ff;
  --color-warning: #f7d060;
  --color-error: #ba4f4f;
  --color-white: #fff;
  --color-info-dark: #7c8894;
  --color-info-darks: #f7d16081;
  --color-dark: #363949;
  --color-light: #848bc82e;
  --color-dark-variant: #677483;
  --color-background: #f5f5f9;

  --card-border-radius: 2rem;
  --border-radius-1: 0.4rem;
  --border-radius-2: 1.2rem;

  --card-padding: 1.8rem;
  --padding-1: 1.2rem;
}
* {
  margin: 0;
  padding: 0;
  outline: 0;
  appearance: 0;
  border: 0;
  text-decoration: none;
  box-sizing: border-box;
}

html {
  font-size: 14px;
}

body {
  height: 100vh;
  font-family: "Poppins", sans-serif;
  font-size: 0.88rem;
  user-select: none;
  overflow: hidden;
  color: var(--color-dark);
  background-color: var(--color-background);
}
.logoCiad {
  width: 200px;
  margin-top: 20px;
  margin-left: 20px;
  /* height: 50px; */
}
.elementLogin {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.rightSection {
  background-color: #fafafa !important;
}
.page {
  height: 100% !important;
  background-color: #fafafa !important;
}
.leftSection {
  border-radius: 10px;
  height: 100vh;
  background-color: #fafafa !important;
}
.lefSectionTop {
  background-color: #e9ae53 !important;
  padding: 20px;
  border-bottom-right-radius: 30px;
}
.lefSectionCenter {
  padding: 10px;
  height: 70vh;
  background-color: #fafafa !important;
}
.lefSectionBottom {
  background-color: #e9ae53 !important;
  padding: 10px;
}
.appTitle {
  color: #fff;
}
.colorText {
  color: #fff !important;
}
.footer {
  background-color: #e9ae53 !important;
}
.logButton {
  height: 50px !important;
  border-radius: 10px;
  background-color: #e9ae53 !important;
  color: #fff !important;
  font-size: 17px !important;
  font-weight: bold !important;
}
.logButton:hover {
  height: 50px !important;
  border-radius: 10px;
  background: #fff !important;
  background: -webkit-linear-gradient(to right, #fff, #fff);
  background: linear-gradient(to right, #fff, #fff);
  color: #e9ae53 !important;
  border: 1px solid #e9ae53;
  font-size: 17px !important;
  font-weight: bold !important;
}
.v-parallax {
  transform: none !important;
  margin-top: 0px;
  width: 100% !important;
  height: 100% !important;
}
.logoImg {
  width: 160px !important;
  height: 80px !important;
}
.form_container {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  gap: 15px;
  padding: 50px 40px 20px 40px;
  background-color: #ffffff;
  -webkit-box-shadow: 0px 106px 42px rgba(0, 0, 0, 0.01),
    0px 59px 36px rgba(0, 0, 0, 0.05), 0px 26px 26px rgba(0, 0, 0, 0.09),
    0px 7px 15px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 106px 42px #00000003, 0px 59px 36px #0000000d,
    0px 26px 26px #00000017, 0px 7px 15px #0000001a, 0px 0px 0px #0000001a;
  border-radius: 11px;
  font-family: "Inter", sans-serif;
}

.logo_container {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 80px;
  height: 80px;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(50%, rgba(248, 248, 248, 0)),
    to(#f8f8f888)
  );
  background: linear-gradient(
    180deg,
    rgba(248, 248, 248, 0) 50%,
    #f8f8f888 100%
  );
  border: 1px solid #f7f7f8;
  -webkit-filter: drop-shadow(0px 0.5px 0.5px #efefef)
    drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  filter: drop-shadow(0px 0.5px 0.5px #efefef)
    drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  border-radius: 11px;
}

.title_container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  gap: 10px;
}

.title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #212121;
}

.subtitle {
  font-size: 0.725rem;
  max-width: 80%;
  text-align: center;
  line-height: 1.1rem;
  color: #8b8e98;
}

.input_container {
  width: 100%;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 5px;
}

.icon {
  width: 20px;
  position: absolute;
  z-index: 99;
  left: 12px;
  bottom: 9px;
}

.input_label {
  font-size: 0.75rem;
  color: #8b8e98;
  font-weight: 600;
}

.input_field {
  width: auto;
  height: 40px;
  padding: 0 0 0 40px;
  border-radius: 7px;
  outline: none;
  border: 1px solid #e5e5e5;
  -webkit-filter: drop-shadow(0px 1px 0px #efefef)
    drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  filter: drop-shadow(0px 1px 0px #efefef)
    drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  -webkit-transition: all 0.3s cubic-bezier(0.15, 0.83, 0.66, 1);
  transition: all 0.3s cubic-bezier(0.15, 0.83, 0.66, 1);
}

.input_field:focus {
  border: 1px solid transparent;
  -webkit-box-shadow: 0px 0px 0px 2px #242424;
  box-shadow: 0px 0px 0px 2px #242424;
  background-color: transparent;
}

.sign-in_btn {
  width: 100%;
  height: 40px;
  border: 0;
  background: #115dfc;
  border-radius: 7px;
  outline: none;
  color: #ffffff;
  cursor: pointer;
}

.sign-in_ggl {
  width: 100%;
  height: 40px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  gap: 10px;
  background: #ffffff;
  border-radius: 7px;
  outline: none;
  color: #242424;
  border: 1px solid #e5e5e5;
  -webkit-filter: drop-shadow(0px 1px 0px #efefef)
    drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  filter: drop-shadow(0px 1px 0px #efefef)
    drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  cursor: pointer;
}

.sign-in_apl {
  width: 100%;
  height: 40px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  gap: 10px;
  background: #212121;
  border-radius: 7px;
  outline: none;
  color: #ffffff;
  border: 1px solid #e5e5e5;
  -webkit-filter: drop-shadow(0px 1px 0px #efefef)
    drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  filter: drop-shadow(0px 1px 0px #efefef)
    drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  cursor: pointer;
}

.separator {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  gap: 30px;
  color: #8b8e98;
}

.separator .line {
  display: block;
  width: 100%;
  height: 1px;
  border: 0;
  background-color: #e8e8e8;
}

.note {
  font-size: 0.75rem;
  color: #8b8e98;
  text-decoration: underline;
}
.container {
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.login-container {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background-color: #ffffff;
}

.left-panel {
  background-image: url("../assets/c.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  flex: 2;
}
.fontComplet {
  background: #e9ae53;
  background: -webkit-linear-gradient(to right, #e9ae5329, #e9ae53);
  background: linear-gradient(to right, #e9ae5329, #e9ae53);
  flex: 1;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.part1 {
  flex: 1;
}
.part2 {
  flex: 3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  padding-left: 40px;
}
.firstName {
  font-size: 95px;
  color: var(--color-white);
  font-weight: bold;
}
.secondElement {
  display: flex;
  font-size: 95px;
  color: var(--color-white);
  font-weight: 100;
}
.thirdElement {
  font-size: 95px;
  color: var(--color-white);
  font-weight: bold;
}
.fourElement {
  color: var(--color-white);
  font-size: 15px;
}
.part3 {
  flex: 1;
  padding-left: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
}
.left-panel h1 {
  margin-top: 0;
  margin-bottom: 30px;
}

.right-panel {
  flex: 1;
  display: flex;
  padding: 30px;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.right-panel .form h4 {
  font-size: 20px;
  font-weight: 700;
  /* margin: 0 0 30px; */
  margin-bottom: 30px;
  color: #2a3444;
}
.form {
  margin: 0 0 30px;
  display: grid;
  gap: 18px;
  width: 400px;
}

.form > input,
.form > button {
  width: 100%;
  height: 50px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}

.form > input {
  border: 2px solid var(--color-primary-solve);
  font-family: inherit;
  font-size: 16px;
  padding: 0 24px;
  color: #11274c;
  transition: all 0.375s;
}

.form > input:hover {
  border: 2px solid var(--color-primary);
}

.form > input::placeholder {
  color: #cac8c8;
}

.form > button {
  cursor: pointer;
  width: 100%;
  height: 50px;
  padding: 0 16px;
  background: var(--color-primary);
  color: #f9f9f9;
  border: 0;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  letter-spacing: 2px;
  transition: all 0.375s;
}

.form > button:hover {
  color: #fff;
  background: var(--color-primary-hard);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.form-group input[type="text"],
.form-group input[type="password"] {
  width: 100%;
  padding: 10px;
  border: 1px solid #cccccc;
  border-radius: 4px;
}

.form-group button {
  background-color: #4caf50;
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.form-group button:hover {
  background-color: #45a049;
}
@media only screen and (max-width: 600px) {
  .login-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  background-color: #ffffff;
}
.logoCiad {
  width: 100px;
  margin-top: 20px;
  margin-left: 20px;
  /* height: 50px; */
}
.thirdElement {
  font-size: 35px;
  color: var(--color-white);
  font-weight: bold;
}
.secondElement {
  display: flex;
  font-size: 25px;
  color: var(--color-white);
  font-weight: 100;
}
.left-panel {
  background-image: url("../assets/c.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  flex: 1;
}
.fontComplet {
  background: #e9ae53;
  background: -webkit-linear-gradient(to right, #e9ae5329, #e9ae53);
  background: linear-gradient(to right, #e9ae5329, #e9ae53);
  flex: 1;
  height: 50vh;
  display: flex;
  flex-direction: column;
}
.part2 {
  flex: 3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  padding-left: 20px;
}
.form {
  margin: 20px;
  display: grid;
  gap: 18px;
  max-width: 400px;
  width: 100%;

}
}
@media only screen and (max-width: 1200px) {
  .login-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  background-color: #ffffff;
}

.logoCiad {
  width: 100px;
  margin-top: 20px;
  margin-left: 20px;
  /* height: 50px; */
}
.thirdElement {
  font-size: 35px;
  color: var(--color-white);
  font-weight: bold;
}
.secondElement {
  display: flex;
  font-size: 25px;
  color: var(--color-white);
  font-weight: 100;
}
.left-panel {
  background-image: url("../assets/c.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  flex: 1;
}
.fontComplet {
  background: #e9ae53;
  background: -webkit-linear-gradient(to right, #e9ae5329, #e9ae53);
  background: linear-gradient(to right, #e9ae5329, #e9ae53);
  flex: 1;
  height: 50vh;
  display: flex;
  flex-direction: column;
}
.part2 {
  flex: 3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  padding-left: 20px;
}
.form {
  margin: 20px;
  display: grid;
  gap: 18px;
  max-width: 400px;
  width: 100%;

}
}
</style>
  